function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 0C2.065 0 0.5 1.565 0.5 3.5C0.5 6.125 4 10 4 10C4 10 7.5 6.125 7.5 3.5C7.5 1.565 5.935 0 4 0ZM1.5 3.5C1.5 2.12 2.62 1 4 1C5.38 1 6.5 2.12 6.5 3.5C6.5 4.94 5.06 7.095 4 8.44C2.96 7.105 1.5 4.925 1.5 3.5ZM2.75 3.5C2.75 2.80964 3.30964 2.25 4 2.25C4.44658 2.25 4.85924 2.48825 5.08253 2.875C5.30582 3.26175 5.30582 3.73825 5.08253 4.125C4.85924 4.51175 4.44658 4.75 4 4.75C3.30964 4.75 2.75 4.19036 2.75 3.5Z"
});

var SvgMapPointer = function SvgMapPointer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMapPointer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map_pointer.4a706b6d.svg";
export { ForwardRef as ReactComponent };